<section id="ngx-datatable-filter">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- ngx-datatable-filter -->
            <fieldset class="form-group">
              <div class="row align-items-end mt-0 pagination-body">

                <div class="col-12 col-sm-12 col-md-3 col-lg-3 mb-2" *ngIf="this.currentUrl == 'allUsers-list'">
                  <div class="btn-group" role="group">
                    <button class="btn" type="button" [ngClass]="{'btn-primary':activeTab=== 'employee','btn-outline-primary':activeTab!=='employee'}"
                      (click)="activeStatusTab(activeTab == 'employee' ? '' :'employee',0 )">Employee</button>
                      <button class="btn" type="button" [ngClass]="{'btn-primary':activeTab=== 'student','btn-outline-primary':activeTab!=='student'}"
                      (click)="activeStatusTab(activeTab=='student'?'':'student',0)">Student</button>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-3 col-lg-3 mb-2" *ngIf="this.currentUrl !== 'allUsers-list'"></div>
                <div class="col-12 col-sm-12 col-md-9 col-lg-9 mt-2 mb-1">
                  <div class="row-flex">
                    <div class="col-flex-2 mb-1 position-relative" *ngIf="currentUrl == 'allUsers-list'">
                      <input id="ngx-filter-ref"
                        class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                        type="text" (keydown.enter)="getFilterUser(searchVal)" placeholder="Search by Name or Email"
                        #name [(ngModel)]="searchVal" />
                      <button class="btn search-btn glow position-absolute" (click)="getFilterUser(searchVal)">
                        <i class="ft-search text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1 position-relative" *ngIf="currentUrl == 'students-list'">
                      <input id="ngx-filter-ref"
                        class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                        type="text" (keydown.enter)="getFilterStudent(searchVal)"
                        placeholder="Search by Name/Email/Phone" #name [(ngModel)]="searchVal" />
                      <button class="btn search-btn glow position-absolute" (click)="getFilterStudent(searchVal)">
                        <i class="ft-search text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1">
                      <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">
                        Reset
                        <i class="ft-filter text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1"
                      *ngIf="currentUrl == 'allUsers-list' && user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                      <button type="button" class="btn btn-primary btn-block users-list-clear glow mb-0"
                       routerLink="/users-add" placement="top" ngbTooltip="Add New">
                        +
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1"
                      *ngIf="currentUrl == 'students-list' && user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                      <button type="button" class="btn btn-primary btn-block users-list-clear glow mb-0"
                       routerLink="/student-add" placement="top" ngbTooltip="Add New">
                        +
                      </button>
                    </div>

                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 pagination-body header-body mb-2">
                  <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                    [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                    [count]="page.totalPages" [offset]="page.pageNumber"
                    (page)="pageChangeData($event)">
                  </ngx-datatable>
                </div>
                <div class="col-12">
                  <button *ngIf="guideline_data && currentUrl == 'allUsers-list'" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Users Guideline</button>
                  <button *ngIf="guideline_data && currentUrl == 'students-list'" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Students Guideline</button>
                  </div>
              </div>
            </fieldset>
            <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
              [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
              [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.pageNumber"
              (page)="pageChangeData($event)">
              <ngx-datatable-column *ngIf="currentUrl == 'allUsers-list'" name="Name" prop="name">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div class="d-flex align-items-left">
                    <div *ngIf="row.image">
                      <img class="rounded-circle mr-1" [src]="imageUrl + row.image" height="32" width="32"
                        alt="datatable-avatar" />
                    </div>
                    <!-- <ng-template #customAvatar> -->
                    <div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
                      <div class="avatar-content">
                        {{ row?.name |titlecase | shortName }}
                      </div>
                    </div>
                    <!-- --------- card ------------------------------------ -->
                    <div class="card-overlay-on-hover">
                      <div class="card">
                        <div class="card-content">
                          <div class="card-img">
                            <img *ngIf="row.image" class="card-img-top img-fluid" [src]="imageUrl + row.image"
                              alt="Card image cap">
                            <div *ngIf="!row.image" class="avatarImg mr-1 ml-0 bg-primary">
                              <div class="avatar-contentImg">{{ row?.name | shortName }}</div>
                            </div>
                          </div>
                          <div class="card-body p-0">
                            <h4>{{row?.name}}</h4>
                            <p>{{row?.email}}</p>
                            <p>{{row?.college?.name}}</p>
                            <p>{{row?.phone}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- ---------------------------------------------------------- -->
                    <div class="cell-line-height">
                      <a class="line-height-1 mb-0" [routerLink]="['/user-view', row._id]"
                        (click)="editUser(row._id)">{{ row.name }}</a>
                    </div>
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="currentUrl == 'students-list'" name="Name" prop="name">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <div class="d-flex align-items-center">
                    <div *ngIf="row.image">
                      <img class="rounded-circle mr-1" [src]="imageUrl + row.image" height="32" width="32"
                        alt="datatable-avatar" />
                    </div>
                    <!-- <ng-template #customAvatar> -->
                    <div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
                      <div class="avatar-content">
                        {{ row?.name |titlecase | shortName }}
                      </div>
                    </div>
                    <!-- --------- card ------------------------------------ -->
                    <div class="card-overlay-on-hover">
                      <div class="card">
                        <div class="card-content">
                          <div class="card-img">
                            <img *ngIf="row.image" class=" card-img-top img-fluid " [src]="imageUrl + row.image"
                              alt="Card image cap">
                            <div *ngIf="!row.image" class="avatarImg mr-1 ml-0 bg-primary">
                              <div class="avatar-contentImg">{{ row?.name | shortName }}</div>
                            </div>
                          </div>
                          <div class="card-body p-0">
                            <h4>{{row?.name}}</h4>
                            <p>{{row?.email}}</p>
                            <p>{{row?.college?.name}}</p>
                            <p>{{row?.phone}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- ---------------------------------------------------------- -->
                    <div class="cell-line-height">
                      <a class="line-height-1 mb-0" [routerLink]="['/user-view', row._id]"
                        (click)="editUser(row._id)">{{ row?.name }}</a>
                    </div>
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="currentUrl == 'allUsers-list'" name="Email"
                prop="email"></ngx-datatable-column>
              <ngx-datatable-column *ngIf="currentUrl == 'students-list'" name="Email" prop="email">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>{{ row?.email }}</ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Contact" prop="phone" [width]="50">
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="activeTab =='student' || currentUrl == 'students-list'" name="Referral By" prop="refrence">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                      <p *ngIf="row?.refrenceid?.length>0; else  notRefrence_id" class="cursor-pointer" (click)="openReferralModal(myModalReferral,row?.id,row?.refrenceid[0]?._id)">{{row?.refrenceid[0]?.name}}</p> 
                      <ng-template #notRefrence_id>
                        <i  class="ft-plus-circle text-primary cursor-pointer  mx-1" (click)="openReferralModal(myModalReferral,row?.id,'')"></i>
                      </ng-template>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="currentUrl == 'students-list'" name="Training Tags" prop="student_tag">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  <p *ngIf="row?.student_tag; else  notTrainingTags" class="cursor-pointer"
                    (click)="openTraingTagsModal(myModalTrainingTags,row)">{{row?.student_tag?.displayname}}</p>
                  <ng-template #notTrainingTags>
                    <i class="ft-plus-circle text-primary cursor-pointer  mx-1"
                      (click)="openTraingTagsModal(myModalTrainingTags,row)"></i>
                  </ng-template>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="currentUrl == 'allUsers-list'" name="Role" prop="roles">
                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                  {{ row.roles }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Actions"
                *ngIf="currentUrl == 'allUsers-list' && user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor' ">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <i *ngIf="user_role.roles =='admin'" class="ft-trash-2 cursor-pointer danger"
                    (click)="ConfirmColor(row._id)"></i>
                  <!-- <i mat-button [matMenuTriggerFor]="menu" class="ft-more-vertical text-primary cursor-pointer mr-2" ></i>
                    <mat-menu #menu="matMenu">
                     <div class="action-btn">
                      <i class="ft-edit text-primary cursor-pointer"></i>
                      <button mat-menu-item  [routerLink]="['/users-edit', row._id]"
                      (click)="editUser(row._id)">Edit</button>
                     </div>
                     <div class="action-btn">
                      <i class="icon-credit-card text-primary cursor-pointer"></i>
                      <button mat-menu-item [routerLink]="'/transaction/transaction-history/' + row._id">Pay</button>
                     </div>
                     <div class="action-btn">
                      <i class="ft-trash-2 text-primary cursor-pointer"></i>
                        <button mat-menu-item (click)="ConfirmColor(row._id)">Delete</button>
                      </div>
                    </mat-menu> -->
                  <!-- <i
                    class="ft-edit text-primary cursor-pointer mr-2"
                    [routerLink]="['/users-edit', row._id]"
                    (click)="editUser(row._id)"
                  ></i>
                  <i
                    class="icon-credit-card cursor-pointer mr-2"
                    [routerLink]="'/transaction/transaction-history/' + row._id"
                  ></i>
                  <i
                    class="ft-trash-2 cursor-pointer danger"
                    (click)="ConfirmColor(row._id)"
                  ></i> -->
                  <!-- </a> -->
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column *ngIf="currentUrl == 'students-list'" name="Activated/Deactivated"
                prop="is_activated">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <div class="custom-switch custom-control-inline mb-1 mb-xl-0">
                    <mat-slide-toggle color="primary" [checked]="row.is_activated"
                      (change)="activateStudent(row)"></mat-slide-toggle>
                  </div>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Actions"
                *ngIf="currentUrl == 'students-list' && user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor' ">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <i mat-button [matMenuTriggerFor]="menu"
                    class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
                  <mat-menu #menu="matMenu">
                    <div class="action-btn">
                      <i class="ft-edit text-primary cursor-pointer"></i>
                      <button mat-menu-item [routerLink]="['/student-edit', row.id]" (click)="editUser(row.id)">
                        Edit
                      </button>
                    </div>
                    <div class="action-btn" *ngIf="user_role.roles =='admin'">
                      <i class="ft-trash-2 text-danger cursor-pointer"></i>
                      <button mat-menu-item (click)="ConfirmColor(row.id)">
                        Delete
                      </button>
                    </div>
                    <div class="action-btn" *ngIf="user_role.roles =='admin'">
                      <i class="ft-lock text-primary cursor-pointer"></i>
                      <button mat-menu-item (click)="changePassword(row.id)">
                        Change Password
                      </button>
                    </div>
                    <div class="action-btn" *ngIf="user_role.roles =='admin'">
                      <i class="ft-clipboard text-primary cursor-pointer"></i>
                      <button mat-menu-item
                      (click)="openModalForOnboarding(myModalOnboarding,row.id)">
                        Onboarding Details
                      </button>
                    </div>
                  </mat-menu>
                  <i class="ft-copy text-primary cursor-pointer mr-2" placement="top" ngbTooltip="Copy Default Password"
                    (click)="copyToClipboard(row.name,row.phone)"></i>
                  <i *ngIf="user_role.roles =='admin'" class="icon-key text-primary cursor-pointer" placement="top"
                    ngbTooltip="set default password" (click)="setDefaultPassword(row?.id, row.name)"></i>
                    <i *ngIf="row?.is_refral === false ||  !row?.is_refral" class="ft-plus-circle text-primary cursor-pointer  mx-1"  placement="bottom" ngbTooltip="Add to Referral"  (click)="openModalForReferral(myModalContent,row?.id,row?.name)"></i>
                  <!-- <i
                    class="ft-edit text-primary cursor-pointer mr-2"
                    [routerLink]="['/student-edit', row._id]"
                    (click)="editUser(row._id)"
                  ></i>
                  <i
                    class="icon-credit-card cursor-pointer mr-2"
                    [routerLink]="'/transaction/transaction-history/' + row._id"
                  ></i>
                  <i
                    class="ft-trash-2 cursor-pointer danger"
                    (click)="ConfirmColor(row._id)"
                  ></i> -->
                  <!-- </a> -->
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>

            <!-- ngx-datatable-filter -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>
<!--/ Filter Datatables -->

<!---------- Add Referral  Popup ---------------->
<div>
	<ng-template #myModalReferral let-modal>
		<div class="modal-header">
			<h4 class="modal-title" *ngIf="selected_emp_referral">Referral Update</h4>
			<h4 class="modal-title" *ngIf="!selected_emp_referral">Referral Add</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form>
				<div class="form-group">
					<label>Referral By</label>
          <ng-select
            [items]="emp_List"
            bindLabel="name"
            color="is_activated"
            bindValue="_id"
            placeholder="Select Referral"
            [(ngModel)]="selected_emp_referral"
            [ngModelOptions]="{ standalone: true }"
            (change)="selectEmpReferralId($event)" 
            [appendTo]="'body'" [virtualScroll]="true" [clearSearchOnAdd]="true"
           >
          </ng-select>
				</div>
			</form>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="referralUpdate()">Submit</button>
		  </div>
	</ng-template>
</div>
<!------------- Referral Popup --------------------------------------->
<div>
	<ng-template #myModalContent>
	  <div class="modal-header">
		<h4 class="modal-title">{{row_name}}'s Referral</h4>
		<button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
		  <span aria-hidden="true">&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
      <fieldset class="form-group" >
				<label>Report To</label>
				<ng-select
				[items]="emp_list"
				bindLabel="name"
				bindValue="user._id"
				[closeOnSelect]="true"
				placeholder="Select"
				[(ngModel)]="referral_model.report_to"
				[ngModelOptions]="{ standalone: true }"
				(change)="getEmpId($event)"
			  ></ng-select>
			  </fieldset>
			  <fieldset class="form-group">
          <label>Notes</label>
          <textarea
          [(ngModel)]="referral_model.notes"
            id="hidden-label-form-6"
            rows="3"
            class="form-control"
            name="notes"
            placeholder="Enter notes"
          ></textarea>
        </fieldset>
        <fieldset class="form-group">
          <label>Admin Notes</label>
          <textarea
          [(ngModel)]="referral_model.admin_notes"
            id="hidden-label-form-6"
            rows="3"
            class="form-control"
            name="admin_notes"
            placeholder="Enter admin notes"
          ></textarea>
        </fieldset>
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
		<button type="button" class="btn btn-primary" (click)="addReferral()">Submit</button>
	  </div>
	</ng-template>
</div>

<!---------- Add Referral  Popup ---------------->
<div>
  <ng-template #myModalTrainingTags let-modal>
    <div class="modal-header">
      <h4 class="modal-title" *ngIf="selected_trainging_tags">Update Training Tags</h4>
      <h4 class="modal-title" *ngIf="!selected_trainging_tags">Add Training Tags</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form>
        <div class="form-group">
          <label>Training Tags</label>
          <ng-select [items]="training_tags_list" bindLabel="name" color="is_activated" bindValue="_id"
            placeholder="Select Tag" [(ngModel)]="selected_trainging_tags" [ngModelOptions]="{ standalone: true }"
            (change)="selectTraingingTagsId($event)" [appendTo]="'body'" [virtualScroll]="true" [clearSearchOnAdd]="true">
          </ng-select>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="trainingTagsUpdate()">Submit</button>
    </div>
  </ng-template>
</div>


<!------------- Popup For Onboarding --------------------------------------->
<div>
  <ng-template #myModalOnboarding>
    <div class="modal-header">
      <h4 class="modal-title" *ngIf="onboarding_data">{{onboarding_data?.student_id[0]?.name}}'s Onboarding</h4>
      <button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" *ngIf="onboarding_data">
      <div class="img-container">
        <div>
          <img  [src]="s3Image + onboarding_data?.photo" alt="profile-img" class="rounded mr-3" height="64" width="64">
        </div>
      </div>
        
        
      <table>
        <tr>
          <td><b>Name :</b></td>
          <td>&nbsp;{{onboarding_data?.student_id[0]?.name}}</td>
        </tr>
        <tr>
          <td><b>About :</b></td>
          <td>&nbsp;{{onboarding_data?.about}}</td>
        </tr>
        <tr>
          <td><b>Resume :</b></td>
          <td>&nbsp;{{onboarding_data?.resume}}</td>
        </tr>
        <tr>
          <td><b>LinkedIn :</b></td>
          <td>&nbsp;{{onboarding_data?.linkedIn}}</td>
        </tr>
      </table>
      </div>
      <div class="modal-body" *ngIf="!onboarding_data">
        <p style="color: red;">Data not found!</p>
      </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
    </div>
  </ng-template>
</div>